import { render, staticRenderFns } from "./pelepasanjaminansebagiansettlementfrm.vue?vue&type=template&id=216413d6&"
import script from "./pelepasanjaminansebagiansettlementfrm.vue?vue&type=script&lang=js&"
export * from "./pelepasanjaminansebagiansettlementfrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports